module.exports = __webpack_public_path__ + "img/firstCustom.23f73ee8.svg";